import { render, staticRenderFns } from "./SponsoredRecommendationImageSearch.vue?vue&type=template&id=0d3a1cb0&scoped=true"
import script from "./SponsoredRecommendationImageSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationImageSearch.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationImageSearch.vue?vue&type=style&index=0&id=0d3a1cb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3a1cb0",
  null
  
)

export default component.exports